import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./About.scss";
import myImg from "../../assets/images/photo.jpeg";
import Hi from "../../assets/images/Hi.gif";
import Type from "./Type";

function About() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const stats = [
    { number: "2", label: "Years Experience" },
    { number: "20+", label: "Projects Built" },
    { number: "15+", label: "Technologies Used" },
    { number: "100%", label: "Dedication" }
  ];

  const techStack = [
    { category: "Languages", skills: ["C++", "Java", "JavaScript", "TypeScript", "SQL"] },
    { category: "Frontend", skills: ["React.js", "HTML5", "CSS3", "Tailwind CSS"] },
    { category: "Backend", skills: ["Node.js", "Express"] },
    { category: "Databases", skills: ["MongoDB", "MySQL"] },
    { category: "Tools", skills: ["Git", "GitHub", "Figma", "Postman", "CI/CD"] }
  ];

  const socialLinks = [
    { name: "GitHub", url: "https://github.com/mohit200008", icon: "fab fa-github" },
    { name: "LinkedIn", url: "https://www.linkedin.com/in/mohit-l-a75076108", icon: "fab fa-linkedin" },
    { name: "Medium", url: "https://ml-assasn.medium.com/", icon: "fab fa-medium" },
    { name: "Stack Overflow", url: "https://stackoverflow.com/users/15060808/mohit-lamba", icon: "fab fa-stack-overflow" },
    { name: "Twitter", url: "https://twitter.com/mohitlamba12", icon: "fab fa-twitter" },
    { name: "Instagram", url: "https://www.instagram.com/mohit_200008/?hl=en", icon: "fab fa-instagram" }
  ];

  return (
    <Container fluid className="about-section" id="about">
      <Container>
        <Row className="align-items-center">
          {/* LEFT CONTENT SECTION */}
          <Col lg={8} md={12} className="about-content">
            <div className={`content-wrapper ${isVisible ? 'fade-in' : ''}`}>
              {/* Greeting Section */}
              <div className="greeting-section">
                <h1 className="greeting-title">
                  Hi <img alt="Hi" src={Hi} className="greeting-gif" />, I'm{" "}
                  <span className="highlight-text">Mohit Lamba</span>
                </h1>
                <div className="title-subtitle">
                  <h2 className="job-title">Software Engineer</h2>
                  <p className="current-role">
                    <i className="fas fa-building"></i>
                    Actian (HCL Software), Bangalore, India
                  </p>
                </div>
                <div className="type-wrapper">
                  <Type />
                </div>
              </div>

              {/* Stats Section */}
              <div className="stats-section">
                <Row>
                  {stats.map((stat, index) => (
                    <Col key={index} xs={6} sm={3} className="stat-item">
                      <div className="stat-card">
                        <div className="stat-number">{stat.number}</div>
                        <div className="stat-label">{stat.label}</div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>

              {/* Terminal Section */}
              <div className="terminal-section">
                <Card className="terminal-card">
                  <div className="terminal-header">
                    <div className="terminal-buttons">
                      <span className="terminal-btn close"></span>
                      <span className="terminal-btn minimize"></span>
                      <span className="terminal-btn maximize"></span>
                    </div>
                    <div className="terminal-title">mohit@portfolio:~</div>
                  </div>
                  <div className="terminal-body">
                    <div className="terminal-line">
                      <span className="prompt">$</span>
                      <span className="command"> cat about.txt</span>
                    </div>
                    <div className="terminal-output">
                      <p>
                        Hello, I'm <strong>Mohit Lamba</strong>, a Software Engineer with 2 years of experience 
                        building enterprise database utilities using <em>Java</em> and <em>Python</em>. 
                        I hold a Bachelor's degree in Information Technology from JIIT-Noida.
                      </p>
                      <p>
                        I currently work at <strong>Actian (HCL Software)</strong> where I commercialize internal 
                        tools, implement command-line utilities for database statistics, and develop APIs for 
                        performance monitoring. I specialize in <em>Java</em>, <em>Python</em>, <em>C++</em>, 
                        and <em>React.js</em> for full-stack development.
                      </p>
                      <p>
                        I enjoy crafting efficient, scalable enterprise applications and solving complex database 
                        performance challenges. I'm deeply interested in <strong>enterprise software development</strong>, 
                        <strong>database optimization</strong>, <strong>API development</strong>, and building 
                        robust troubleshooting utilities.
                      </p>
                    </div>
                  </div>
                </Card>
              </div>

              {/* Action Buttons */}
              <div className="action-buttons">
                <a
                  href="https://drive.google.com/file/d/14rZNig6z_4W2TUw3yLKiy6HXB4aBXAiM/view?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary btn-resume"
                >
                  <i className="fas fa-download"></i>
                  Download Resume
                </a>
                <a
                  href="#contact"
                  className="btn btn-outline-primary btn-contact"
                >
                  <i className="fas fa-envelope"></i>
                  Get In Touch
                </a>
              </div>

              {/* Social Links */}
              <div className="social-section">
                <h5 className="social-title">Connect with me</h5>
                <div className="social-links">
                  {socialLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-link"
                      title={social.name}
                    >
                      <i className={social.icon}></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </Col>

          {/* RIGHT IMAGE SECTION */}
          <Col lg={4} md={12} className="image-section">
            <div className={`image-wrapper ${isVisible ? 'slide-in' : ''}`}>
              <div className="profile-image-container">
                <img src={myImg} className="profile-image" alt="Mohit Lamba" />
                <div className="image-overlay"></div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default About;
